"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityField = exports.PriceField = exports.NameField = exports.InformationsStepFields = exports.ImagesField = exports.DescriptionField = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _formValidators = require("react-platform-components/dist/form-validators");
var _formik = require("formik");
var _uploader = require("react-platform-components/dist/uploader");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _index = require("react-platform-components/dist/form-fields/index");
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _TutorialDialog = _interopRequireDefault(require("react-platform-components/dist/Hints/TutorialDialog"));
var _config = require("../../../config");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var CategoryOfProductNotFinal = null;
try {
  if (_config.USE_NEW_DESIGN_OF_CATEGORIES_OF_PRODUCT_FIELD) {
    CategoryOfProductNotFinal = require("react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField/CategoryOfProductField").CategoryOfProductField;
  } else {
    CategoryOfProductNotFinal = require("react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField").default;
  }
} catch (e) {}
var SpecificitiesOfProductFields = null;
try {
  SpecificitiesOfProductFields = require("react-platform-specificity-of-product/dist/SpecificityOfProductWithSections/SpecificitiesOfProductFields").SpecificitiesOfProductFields;
} catch (error) {}
var CautionField = null;
try {
  CautionField = require('react-platform-caution/dist/CautionField/CautionField').CautionField;
} catch (error) {
  console.log('module caution not exist');
}
var NameField = function NameField() {
  return /*#__PURE__*/_react.default.createElement(_index.TextField, {
    name: "name",
    label: "Nom de l'article",
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("name"),
    validate: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("name") ? (0, _formValidators.required)(_config.CUSTOM_MESSAGE_ERROR_NAME) : null,
    placeholder: "Nom de l'article",
    endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      "aria-label": "toggle password visibility",
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      title: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "Citez simplement le nom de votre produit, sans mentionner de caract\xE9ristiques ou d\u2019adjectifs ex  poussette yoyo / sac \xE0 langer / tour de lit / chaise haute",
        defaultMessage: "Citez simplement le nom de votre produit, sans mentionner de caract\xE9ristiques ou d\u2019adjectifs ex  poussette yoyo / sac \xE0 langer / tour de lit / chaise haute"
      })
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  });
};
exports.NameField = NameField;
var DescriptionField = function DescriptionField(_ref) {
  var _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 7 : _ref$rows;
  return /*#__PURE__*/_react.default.createElement(_index.TextField, {
    name: "description",
    label: "Description",
    margin: "normal",
    variant: "outlined",
    placeholder: "Description",
    endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      "aria-label": "toggle password visibility",
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "Soyez bavards. Votre acheteur a besoin de tout savoir pour choisir votre article. Pensez \xE0 bien mentionner:",
        defaultMessage: "Soyez bavards. Votre acheteur a besoin de tout savoir pour choisir votre article. Pensez \xE0 bien mentionner:"
      }), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: " L\u2019\xE9tat du produit "
      })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "  La pr\xE9sence de d\xE9fauts quelconques "
      })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: " Les caract\xE9ristiques propres au produit "
      }))))
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))),
    multiline: true,
    rows: rows,
    fullWidth: true,
    required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("description"),
    validate: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("description") ? (0, _formValidators.required)() : null
  });
};
exports.DescriptionField = DescriptionField;
var PriceField = function PriceField() {
  return /*#__PURE__*/_react.default.createElement(_index.TextField, {
    name: "price",
    label: "Prix",
    margin: "normal",
    variant: "outlined",
    placeholder: "Price",
    fullWidth: true,
    endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      "aria-label": "toggle password visibility",
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      title: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "La fixation du prix vous appartient. N\xE9anmoins, nous vous conseillons de fixer un prix raisonnable pour que votre annonce soit retenue par nos acheteurs. N\u2019h\xE9sitez pas \xE0: Ajuster le prix dans le temps si vous pensez que cela pourrait aider \xE0 la vente Activer l\u2019option de n\xE9gociation: vous pourriez accepter la proposition d\u2019un acheteur Consid\xE9rer les prix propos\xE9s par d\u2019autres vendeurs sur des articles similaires Le prix affich\xE9 est le prix pay\xE9 par l\u2019acheteur, affich\xE9 publiquement sur notre site. Le prix pour vous correpond au prix pay\xE9 par l'acheteur duquel nous d\xE9duisons notre commission. C'est le prix qui vous sera vers\xE9. ",
        defaultMessage: "La fixation du prix vous appartient. N\xE9anmoins, nous vous conseillons de fixer un prix raisonnable pour que votre annonce soit retenue par nos acheteurs. N\u2019h\xE9sitez pas \xE0: Ajuster le prix dans le temps si vous pensez que cela pourrait aider \xE0 la vente Activer l\u2019option de n\xE9gociation: vous pourriez accepter la proposition d\u2019un acheteur Consid\xE9rer les prix propos\xE9s par d\u2019autres vendeurs sur des articles similaires Le prix affich\xE9 est le prix pay\xE9 par l\u2019acheteur, affich\xE9 publiquement sur notre site. Le prix pour vous correpond au prix pay\xE9 par l'acheteur duquel nous d\xE9duisons notre commission. C'est le prix qui vous sera vers\xE9. "
      })
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))),
    required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("price"),
    validate: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("price") ? (0, _formValidators.validators)([(0, _formValidators.required)(_config.CUSTOM_MESSAGE_ERROR_PRIX), (0, _formValidators.number)(), (0, _formValidators.isPositive)()]) : (0, _formValidators.validators)([(0, _formValidators.number)(), (0, _formValidators.isPositive)()])
  });
};
exports.PriceField = PriceField;
var QuantityField = function QuantityField() {
  return /*#__PURE__*/_react.default.createElement(_index.TextField, {
    name: "quantity",
    label: "Quantit\xE9",
    margin: "normal",
    variant: "outlined",
    placeholder: "Quantit\xE9",
    required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("quantity"),
    fullWidth: true,
    validate: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("quantity") ? (0, _formValidators.validators)([(0, _formValidators.number)(), (0, _formValidators.isPositive)(), (0, _formValidators.required)()]) : (0, _formValidators.validators)([(0, _formValidators.isPositive)(), (0, _formValidators.number)()])
  });
};
exports.QuantityField = QuantityField;
var ImagesField = function ImagesField(props) {
  var _useFormikContext = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext.setFieldValue;
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    name: "images",
    label: "Images",
    value: props.values.images,
    maxImages: _config.MAX_IMAGES_IN_PRODUCT_CREATION,
    acceptedFiles: "image/bmp,image/jpeg,image/png,image/x-ms-bmp",
    component: _uploader.renderMultiImagesFieldWithMainImage,
    required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("images"),
    validate: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("images") ? (0, _formValidators.required)(_config.CUSTOM_MESSAGE_ERROR_IMAGE) : null,
    onDelete: function onDelete(id) {
      return setFieldValue("images-to-delete", props.values["images-to-delete"] ? [].concat(_toConsumableArray(props.values["images-to-delete"]), [id]) : [id]);
    },
    fullWidth: true,
    extraContainerStyles: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    openCamera: false
  }, props));
};
exports.ImagesField = ImagesField;
var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    flex: {
      display: "flex"
    },
    typo1: {
      color: "#757575",
      fontSize: 13
    },
    typo2: {
      fontSize: 14,
      fontWeight: "600",
      lineHeight: "18.4px",
      marginBottom: "20px"
    },
    typo3: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "center",
      marginBottom: "20px"
    },
    marginBottom: {
      marginBottom: "10px"
    },
    cardStyle: {
      border: "1px solid black",
      marginTop: "5px"
    },
    conseils: {
      fontSize: 14,
      fontWeight: "600",
      textAlign: "center"
    },
    cardText1: {
      fontSize: 11,
      fontWeight: "400",
      lineHeight: "18.4px",
      textAlign: "left",
      wordSpacing: "0",
      color: "#263238"
    },
    cardText2: {
      fontSize: 11,
      fontWeight: "400",
      textAlign: "left"
    },
    cardText3: {
      fontSize: 11,
      fontWeight: "400",
      textAlign: "left",
      margin: "0",
      color: "rgb(38, 50, 56)"
    },
    cardText4: {
      fontSize: 11,
      textAlign: "left",
      fontWeight: "400",
      lineHeight: "18.4px",
      marginBottom: "20px",
      marginTop: "10px"
    },
    images: {
      display: "flex",
      justifyContent: "center",
      gap: "15px",
      width: "max-content"
    },
    justifyContentCenter: {
      justifyContent: "center"
    },
    examplePicturesBottom: {
      height: "130px",
      width: "130px"
    },
    displayFlex: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 10
    },
    categoryStyling: {
      marginTop: "12px"
    },
    paperContainer: {
      display: "flex",
      justifyContent: "space-between",
      position: "sticky",
      top: "64px",
      zIndex: "100",
      padding: "5px 10px",
      background: "#EAE7E7"
    },
    stepsWrapper: {
      paddingLeft: "35px",
      paddingBottom: "80px"
    },
    bottomWrapper: {
      position: "sticky",
      bottom: 0,
      zIndex: "100"
    },
    containerStyle: {
      position: "fixed",
      bottom: "0",
      zIndex: "100",
      height: "70px"
    },
    previousButton: {
      background: theme.palette.primary.main,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer"
    },
    nextButton: {
      background: theme.palette.primary.main,
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "15px",
      alignItems: "center",
      alignContent: "center",
      cursor: "pointer"
    },
    submitButton: {
      background: theme.palette.primary.main,
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "25px",
      alignItems: "center",
      alignContent: "center",
      cursor: "pointer",
      color: "red"
    },
    coloredSubmitButton: {
      color: "red",
      backgroundColor: "transparent"
    },
    stepperStyling: {
      background: theme.palette.primary.main,
      height: "100%"
    },
    addProductText: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    savedAsDraft: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "15px"
    },
    fab: {
      position: 'fixed',
      bottom: "100px",
      right: "25px",
      zIndex: "5000"
    },
    priceMargin: {
      margin: "-8px 0"
    }
  };
});
var InformationsStepFields = function InformationsStepFields(props) {
  var _$first;
  var params = (0, _reactRouterDom.useParams)();
  var _useFormikContext2 = (0, _formik.useFormikContext)(),
    values = _useFormikContext2.values,
    setFieldValue = _useFormikContext2.setFieldValue,
    setFieldTouched = _useFormikContext2.setFieldTouched,
    submitCount = _useFormikContext2.submitCount;
  var state = (0, _reactRedux.useSelector)(function (state) {
    var _state$productSalable;
    return {
      productSalableCommission: state === null || state === void 0 ? void 0 : (_state$productSalable = state.productSalableReducer) === null || _state$productSalable === void 0 ? void 0 : _state$productSalable.commissions,
      categories: state === null || state === void 0 ? void 0 : state.categoryOfProductReducer,
      product: state.ProductReducer.product
    };
  });
  var defaultCommission = state === null || state === void 0 ? void 0 : state.productSalableCommission;
  var isMd = (0, _core.useMediaQuery)("(max-width: 810px)");
  var commission = (_$first = _lodash.default.first(defaultCommission === null || defaultCommission === void 0 ? void 0 : defaultCommission.commission_users)) !== null && _$first !== void 0 ? _$first : defaultCommission;
  var priceAfter = _config.USE_SELLER_COMMISSION && values !== null && values !== void 0 && values.price && (values === null || values === void 0 ? void 0 : values.price) !== "" ? commission.value ? (values === null || values === void 0 ? void 0 : values.price) * (1 - (commission === null || commission === void 0 ? void 0 : commission.value)) : (values === null || values === void 0 ? void 0 : values.price) - ((commission === null || commission === void 0 ? void 0 : commission.price) || 0) : "";
  var classes = useStyle();
  var PriceComponent = props.priceComponent || PriceField;
  var CategoryOfProductComponent = props.categoryOfProductComponent || CategoryOfProductNotFinal;
  var product = params.id ? state.product : {};
  if (!isMd) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_TutorialDialog.default, {
      title: "Title_photos_tutorial_dialog",
      showText: "Voir astuces",
      openText: "Ajoute jusqu'\xE0 5 photos.",
      type: "create_products_images"
    }), /*#__PURE__*/_react.default.createElement(ImagesField, {
      values: values
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 6,
      md: 6,
      spacing: 0
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(NameField, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, CategoryOfProductComponent && /*#__PURE__*/_react.default.createElement(CategoryOfProductComponent, {
      values: values,
      setFieldValue: setFieldValue,
      setFieldTouched: setFieldTouched,
      required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("category")
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12,
      className: classes.priceMargin
    }, _config.PRODUCT_SHOULD_HAVE_PRICE && /*#__PURE__*/_react.default.createElement(PriceComponent, null), _config.USE_SELLER_COMMISSION && priceAfter && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, (values === null || values === void 0 ? void 0 : values.price) && (values === null || values === void 0 ? void 0 : values.price) !== "" && !isNaN(priceAfter) && /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.typo1,
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "La vente de cet article vous rapportera ".concat(priceAfter.toFixed(2), "\u20AC"),
      defaultMessage: "La vente de cet article vous rapportera ".concat(priceAfter.toFixed(2), "\u20AC")
    }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12,
      spacing: 2
    }, _config.SHOW_QUANTITY_FIELD_IN_PRODUCT_CREATION && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(QuantityField, null))))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      xs: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(DescriptionField, null))), CautionField && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(CautionField, null)), SpecificitiesOfProductFields && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(SpecificitiesOfProductFields, _extends({}, props, {
      product: product,
      submitCount: submitCount,
      isMd: isMd
    }))));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(NameField, null))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(DescriptionField, null))), /*#__PURE__*/_react.default.createElement("br", null), CategoryOfProductComponent && /*#__PURE__*/_react.default.createElement(CategoryOfProductComponent, {
    values: values,
    required: _config.REQUIRED_FIELDS_IN_CREATION_FORM.includes("category")
  }), SpecificitiesOfProductFields && /*#__PURE__*/_react.default.createElement(SpecificitiesOfProductFields, _extends({}, props, {
    product: product,
    submitCount: submitCount,
    isMd: isMd
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    xs: 12,
    md: 12,
    spacing: 0
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, _config.PRODUCT_SHOULD_HAVE_PRICE && /*#__PURE__*/_react.default.createElement(PriceComponent, null)), _config.SHOW_QUANTITY_FIELD_IN_PRODUCT_CREATION && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(QuantityField, null))), _config.USE_SELLER_COMMISSION && priceAfter && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, (values === null || values === void 0 ? void 0 : values.price) && (values === null || values === void 0 ? void 0 : values.price) !== "" && !isNaN(priceAfter) && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.typo1,
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "La vente de cet article vous rapportera ".concat(priceAfter.toFixed(2), "\u20AC"),
    defaultMessage: "La vente de cet article vous rapportera ".concat(priceAfter.toFixed(2), "\u20AC")
  }))), CautionField && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(CautionField, null))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 12,
    className: classes.displayFlex
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_TutorialDialog.default, {
    title: "Title_photos_tutorial_dialog",
    showText: "Voir astuces",
    openText: "Ajoute jusqu'\xE0 5 photos.",
    type: "create_products_images"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(ImagesField, {
    values: values
  })))));
};
exports.InformationsStepFields = InformationsStepFields;